// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6f118ff2","245":"f432edff","800":"9ebc44e9","943":"866624ef"}[chunkId] + ".chunk.js";
};